import Icon from "@ant-design/icons"
import { ReactComponent as JapanFlag } from "./japan.svg"

const JapanFlagIcon = (props: any) => <Icon component={JapanFlag} {...props} />

export default JapanFlagIcon
